import { CommonModule, CurrencyPipe, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CalendarModule } from 'primeng/calendar';

// Components
import * as fromComponents from './components';

// Pipes
import * as fromPipes from './pipes';

// Directive + if more than one create an index.ts
import { DgxComponentsIconModule } from '@domgen/dgx-fe-components/icon';
import { DgxQmModule } from '@domgen/dgx-fe-qm';
import { SortcodeDirective } from './directives/sortcode.directive';

@NgModule({
  declarations: [
    ...fromComponents.components,
    ...fromPipes.pipes,
    SortcodeDirective,
  ],
  imports: [
    CommonModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    FormsModule,
    CalendarModule,
    DgxQmModule.forRoot(),
    DgxComponentsIconModule,
  ],
  exports: [
    ...fromComponents.components,
    ...fromPipes.pipes,
    SortcodeDirective,
    CalendarModule,
  ],
  providers: [CurrencyPipe, DatePipe, fromPipes.DateFormatPipe, fromPipes.TimeFormatPipe],
})
export class SharedModule {}
